import React from 'react';
import { FaFilm } from 'react-icons/fa';

const GenreFilter = ({ genreFilter, setGenreFilter }) => {
  const handleGenreChange = (event) => {
    setGenreFilter(event.target.value);
  };

  return (
    <div className="filter-control-item">
      <label htmlFor="genre-filter" className="filter-control-label">
        <FaFilm className="icon-purple" /> Genre
      </label>
      <select
        id="genre-filter"
        className="filter-select-custom"
        value={genreFilter}
        onChange={handleGenreChange}
        aria-label="Filter by genre"
      >
        <option value="all">All Genres</option>
        <option value="28">Action & Adventure</option>
        <option value="16">Animation</option>
        <option value="35">Comedy</option>
        <option value="18">Drama</option>
        <option value="878">Sci-Fi & Fantasy</option>
        <option value="27">Horror</option>
        <option value="53">Thriller & Mystery</option>
        <option value="10751">Family</option>
        <option value="99">Documentary</option>
      </select>
    </div>
  );
};

export default GenreFilter;